import { Record, Union } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Types.js";
import { list_type, class_type, record_type, bool_type, option_type, obj_type, union_type, string_type } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Reflection.js";
import { ofArray, singleton, map, toArray } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/List.js";
import { FSharpResult$2 } from "../Bfs.Web.Kundenportal/fable_modules/fable-library-js.4.19.0/Result.js";

export class Remote$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Empty", "Loading", "LoadError", "Body"];
    }
}

export function Remote$1_$reflection(gen0) {
    return union_type("Types.Remote`1", [gen0], Remote$1, () => [[], [], [["Item", string_type]], [["Item", gen0]]]);
}

export class GlobalMessageType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SuccessBox", "InfoBox", "WarningBox", "ErrorBox"];
    }
}

export function GlobalMessageType_$reflection() {
    return union_type("Types.GlobalMessageType", [], GlobalMessageType, () => [[], [], [], []]);
}

export class GlobalMessageBoxButtonType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["YesButton", "NoButton", "OkButton", "CancelButton"];
    }
}

export function GlobalMessageBoxButtonType_$reflection() {
    return union_type("Types.GlobalMessageBoxButtonType", [], GlobalMessageBoxButtonType, () => [[], [], [], []]);
}

export class GlobalMessageBoxButton extends Record {
    constructor(Type, Caption, Message, ClosesDialog) {
        super();
        this.Type = Type;
        this.Caption = Caption;
        this.Message = Message;
        this.ClosesDialog = ClosesDialog;
    }
}

export function GlobalMessageBoxButton_$reflection() {
    return record_type("Types.GlobalMessageBoxButton", [], GlobalMessageBoxButton, () => [["Type", GlobalMessageBoxButtonType_$reflection()], ["Caption", string_type], ["Message", option_type(obj_type)], ["ClosesDialog", bool_type]]);
}

export function YesButton(message) {
    return new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(0, []), "Ja", message, true);
}

export function NoButton(message) {
    return new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(1, []), "Nein", message, true);
}

export function OkButton(message) {
    return new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(2, []), "OK", message, true);
}

export function CanelButton(message) {
    return new GlobalMessageBoxButton(new GlobalMessageBoxButtonType(3, []), "Abbrechen", message, true);
}

export class Video extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Vimeo"];
    }
}

export function Video_$reflection() {
    return union_type("Types.Video", [], Video, () => [[["Item", string_type]]]);
}

export class GlobalMessageBox extends Record {
    constructor(Type, Title, BodyElement, Buttons) {
        super();
        this.Type = Type;
        this.Title = Title;
        this.BodyElement = BodyElement;
        this.Buttons = Buttons;
    }
}

export function GlobalMessageBox_$reflection() {
    return record_type("Types.GlobalMessageBox", [], GlobalMessageBox, () => [["Type", GlobalMessageType_$reflection()], ["Title", string_type], ["BodyElement", class_type("Fable.React.ReactElement")], ["Buttons", list_type(GlobalMessageBoxButton_$reflection())]]);
}

function GlobalMessageBox_messagesToContentElement_7F866359(messages) {
    return toArray(map((s) => s, messages));
}

function GlobalMessageBox_messageToContentElement_Z721C83C5(message) {
    return message;
}

export function GlobalMessageBox_Error_Z721C83C5(message) {
    return new GlobalMessageBox(new GlobalMessageType(3, []), "Es ist ein Fehler aufgetreten", GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_ErrorWithTitle(title, message) {
    return new GlobalMessageBox(new GlobalMessageType(3, []), title, GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Errors_7F866359(messages) {
    return new GlobalMessageBox(new GlobalMessageType(3, []), "Es ist ein Fehler aufgetreten", GlobalMessageBox_messagesToContentElement_7F866359(messages), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Warning_Z721C83C5(message) {
    return new GlobalMessageBox(new GlobalMessageType(2, []), "Bitte beachten Sie folgende Warnung", GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_WarningWithTitle(title, message) {
    return new GlobalMessageBox(new GlobalMessageType(2, []), title, GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Warnings_7F866359(messages) {
    return new GlobalMessageBox(new GlobalMessageType(2, []), "Bitte beachten Sie folgenden Warnungen", GlobalMessageBox_messagesToContentElement_7F866359(messages), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Info_Z721C83C5(message) {
    return new GlobalMessageBox(new GlobalMessageType(1, []), "Information", GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_HtmlInfoWithTitle(title, content) {
    return new GlobalMessageBox(new GlobalMessageType(1, []), title, content, singleton(OkButton(undefined)));
}

export function GlobalMessageBox_InfoWithTitle(title, message) {
    return new GlobalMessageBox(new GlobalMessageType(1, []), title, GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Infos_7F866359(messages) {
    return new GlobalMessageBox(new GlobalMessageType(1, []), "Information", GlobalMessageBox_messagesToContentElement_7F866359(messages), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Success_Z721C83C5(message) {
    return new GlobalMessageBox(new GlobalMessageType(0, []), "Information", GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_SuccessWithTitle(title, message) {
    return new GlobalMessageBox(new GlobalMessageType(0, []), title, GlobalMessageBox_messageToContentElement_Z721C83C5(message), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_Successes_7F866359(messages) {
    return new GlobalMessageBox(new GlobalMessageType(0, []), "Information", GlobalMessageBox_messagesToContentElement_7F866359(messages), singleton(OkButton(undefined)));
}

export function GlobalMessageBox_ConfirmationBox(title, message, yesMsg) {
    return new GlobalMessageBox(new GlobalMessageType(2, []), title, GlobalMessageBox_messageToContentElement_Z721C83C5(message), ofArray([YesButton(yesMsg), NoButton(undefined)]));
}

export class UserSession extends Record {
    constructor(Name, Email, Roles, IsNewCustomer, SessionData) {
        super();
        this.Name = Name;
        this.Email = Email;
        this.Roles = Roles;
        this.IsNewCustomer = IsNewCustomer;
        this.SessionData = SessionData;
    }
}

export function UserSession_$reflection() {
    return record_type("Types.UserSession", [], UserSession, () => [["Name", string_type], ["Email", string_type], ["Roles", list_type(string_type)], ["IsNewCustomer", bool_type], ["SessionData", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]);
}

export class GlobalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoginValidated", "Logoff", "LogoffValidated", "ShowMessageBox", "ClearMessageBox", "ShowVideo", "ClearVideo", "UpdateUserSessionData"];
    }
}

export function GlobalMsg_$reflection() {
    return union_type("Types.GlobalMsg", [], GlobalMsg, () => [[["newUserSession", UserSession_$reflection()], ["gotoUrl", option_type(string_type)]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMessageBox_$reflection()]], [], [["Item", Video_$reflection()]], [], [["key", string_type], ["value", string_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GlobalMsg", "WebPartMsg", "UrlUpdated", "NavigateTo", "NavigateHome", "ToggleBurgerMenu", "ToggleNotificationMenu", "HandleChatWidget"];
    }
}

export function Msg_$reflection() {
    return union_type("Types.Msg", [], Msg, () => [[["Item", GlobalMsg_$reflection()]], [["Item", obj_type]], [["Item", obj_type]], [["Item", obj_type]], [], [], [], [["Item", UserSession_$reflection()]]]);
}

export class Model extends Record {
    constructor(Page, PageModel, User, VideoOverlayVimeoId, MessageBox, IsBurgerMenuOpen, IsNotificationMenuOpen) {
        super();
        this.Page = Page;
        this.PageModel = PageModel;
        this.User = User;
        this.VideoOverlayVimeoId = VideoOverlayVimeoId;
        this.MessageBox = MessageBox;
        this.IsBurgerMenuOpen = IsBurgerMenuOpen;
        this.IsNotificationMenuOpen = IsNotificationMenuOpen;
    }
}

export function Model_$reflection() {
    return record_type("Types.Model", [], Model, () => [["Page", obj_type], ["PageModel", obj_type], ["User", option_type(UserSession_$reflection())], ["VideoOverlayVimeoId", option_type(Video_$reflection())], ["MessageBox", option_type(GlobalMessageBox_$reflection())], ["IsBurgerMenuOpen", bool_type], ["IsNotificationMenuOpen", bool_type]]);
}

export class PageHeader extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoHeader", "Header", "HeaderWithSubheader"];
    }
}

export function PageHeader_$reflection() {
    return union_type("Types.PageHeader", [], PageHeader, () => [[], [["Item", string_type]], [["Item1", string_type], ["Item2", string_type]]]);
}

//# sourceMappingURL=Types.fs.js.map
